import { Component, OnInit } from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';
import {ApiService} from '../../../shared/services/api.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.component.html',
  styles: []
})

export class EvaluationComponent implements OnInit {

  loadingIndicator = true;
  loadingIndicatorDataManagement = true;

  marketStatisticsAvailableYears = [0];
  marketStatisticsSelectedYears = 0;
  marketStatisticsArray = [];
  marketStatisticsArrayFiltered = [];
  marketStatisticsDataManagementArray = [];
  marketStatisticsDataManagementArrayFiltered = [];
  marketStatisticsPerPage = 52;

  total =  {
    marketdates: 0,
    accountingsAll: 0,
    accountingsWithoutAbsent: 0,
    sqmAll: 0,
    sqmWithoutAbsent: 0,
    sumPriceTotal: 0,
    marketmanagers: 0
  };

  constructor(private jhiLanguageService: JhiLanguageService, private apiService: ApiService) {
    this.jhiLanguageService.setLocations(['evaluation']);
  }

  ngOnInit() {
    this.loadingIndicator = true;
    this.getMarketStatistics();
    this.loadingIndicatorDataManagement = true;
    this.getMarketStatisticsDataManagement();
  }

  getMarketStatistics() {
    this.apiService.get('backoffice/market-statistics')
      .subscribe(response => {
        const marketStatisticsRaw = response.json() as { id: string, indexName: string, year: number, week: number, value: number }[];
        const marketStatistics = new Map();

        marketStatisticsRaw.forEach(
          (statistic) => {
            const key = statistic.year + '-' + statistic.week;
            if (!this.marketStatisticsAvailableYears.includes(statistic.year)) {
              this.marketStatisticsAvailableYears.push(statistic.year);
            }
            let item =  {year: statistic.year, week: statistic.week,
              marketdates: 0,
              accountingsAll: 0,
              accountingsWithoutAbsent: 0,
              sqmAll: 0,
              sqmWithoutAbsent: 0,
              sumPriceTotal: 0,
              marketmanagers: 0
            };

            if (marketStatistics.has(key)) {
              item = marketStatistics.get(key);
            }

            item[statistic.indexName] = statistic.value;
            this.total[statistic.indexName] += statistic.value;

            marketStatistics.set(key, item);
          }
        );
        this.marketStatisticsArray = this.mapToArray(marketStatistics);
        this.filterByYear(new Date().getFullYear());
        this.loadingIndicator = false;

      });
  }

  getMarketStatisticsDataManagement() {
    this.apiService.get('backoffice/market-statistics-data-management')
      .subscribe(response => {
        const marketStatisticsRaw = response.json() as {
          branchId: number,
          branchString: string,
          id: string,
          indexName: string
          year: number,
          month: number,
          value: number
        }[];
        this.marketStatisticsDataManagementArrayFiltered = marketStatisticsRaw;

        this.loadingIndicatorDataManagement = false;

      });
  }


  mapToArray(marketStatistics: any) {
    const result = [];
    const entries = Array.from(marketStatistics.entries()).sort((a, b) => (a > b) ? -1 : 1);
    entries.map(
      (entry) => {
        result.push(entry[1]);
      }
    );
    return result;
  }

  saveMarketStatisticsToCsv() {
    const headers = [
      'Jahr',
      'Woche',
      'Markttabrechnungen',
      'VE',
      'VE ohne Abw.',
      'Fläche',
      'Fläche ohne Abw.',
      'Abgerechnet',
      'Marktleitung'];
    let body = headers.join(';') + '\r\n';

    this.marketStatisticsArrayFiltered.forEach(
      (entry) => {
        body = body.concat(entry.year, ';');
        body = body.concat(entry.week, ';');
        body = body.concat(entry.marketdates, ';');
        body = body.concat(entry.accountingsAll, ';');
        body = body.concat(entry.accountingsWithoutAbsent, ';');
        body = body.concat(entry.sqmAll, ';');
        body = body.concat(entry.sqmWithoutAbsent, ';');
        body = body.concat('' + Math.round(entry.sumPriceTotal * 100) / 100, ';');
        body = body.concat(entry.marketmanagers, ';\r\n');
      }
    );
    const blob = new Blob([body], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, 'Marktabrechnungsstatistik.csv');
  }

  filterByYear(year: number) {
    this.marketStatisticsArrayFiltered = this.marketStatisticsArray.filter((entry) => (year === 0) ? true : entry.year === year);
    this.marketStatisticsSelectedYears = year;
  }

}



// WEBPACK FOOTER //
// ./src/app/evaluation/components/evaluation/evaluation.component.ts